import { createIcon } from '../utils';

export const CircleCheckmarkIcon = createIcon({
  displayName: 'CircleCheckmarkIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25ZM3.71875 7L4.53906 6.1493L6.17969 7.85069L9.4609 4.44792L10.2812 5.29861L6.17969 9.5521L3.71875 7Z"
      fill="currentColor"
    />
  ),
});

export const CircleEllipsisIcon = createIcon({
  displayName: 'CircleEllipsisIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25ZM8.6719 7.5156C8.80865 7.65235 8.99411 7.72917 9.1875 7.72917C9.38089 7.72917 9.56635 7.65235 9.7031 7.5156C9.83984 7.37886 9.91667 7.19339 9.91667 7C9.91667 6.80662 9.83984 6.62115 9.7031 6.48441C9.56635 6.34766 9.38089 6.27084 9.1875 6.27084C8.99411 6.27084 8.80865 6.34766 8.6719 6.48441C8.53516 6.62115 8.45833 6.80662 8.45833 7C8.45833 7.19339 8.53516 7.37886 8.6719 7.5156ZM4.2969 7.5156C4.43365 7.65235 4.61911 7.72917 4.8125 7.72917C5.00589 7.72917 5.19135 7.65235 5.3281 7.5156C5.46484 7.37886 5.54167 7.19339 5.54167 7C5.54167 6.80662 5.46484 6.62115 5.3281 6.48441C5.19135 6.34766 5.00589 6.27084 4.8125 6.27084C4.61911 6.27084 4.43365 6.34766 4.2969 6.48441C4.16016 6.62115 4.08333 6.80662 4.08333 7C4.08333 7.19339 4.16016 7.37886 4.2969 7.5156ZM6.4844 7.5156C6.62115 7.65235 6.80661 7.72917 7 7.72917C7.19339 7.72917 7.37885 7.65235 7.5156 7.5156C7.65234 7.37886 7.72917 7.19339 7.72917 7C7.72917 6.80662 7.65234 6.62115 7.5156 6.48441C7.37885 6.34766 7.19339 6.27084 7 6.27084C6.80661 6.27084 6.62115 6.34766 6.4844 6.48441C6.34766 6.62115 6.27083 6.80662 6.27083 7C6.27083 7.19339 6.34766 7.37886 6.4844 7.5156Z"
      fill="currentColor"
    />
  ),
});

export const CircleMinusIcon = createIcon({
  displayName: 'CircleMinusIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25ZM9.91667 6.27084H4.08334V7.72917H9.91667V6.27084Z"
      fill="currentColor"
    />
  ),
});

export const CirclePlusIcon = createIcon({
  displayName: 'CirclePlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM10.9619 7.38086L10.9844 8.39648V10.9619L8.39648 10.9844H7.35938V13.0156H8.39648L10.9844 13.0381V15.6035L10.9619 16.6191L13.0156 16.6406V12.9941L15.6035 13.0156L16.6191 13.0381V10.9619L15.6035 10.9844L13.0156 11.0059V7.35938L10.9619 7.38086Z"
      fill="currentColor"
    />
  ),
});

export const CirclePauseIcon = createIcon({
  displayName: 'CirclePauseIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25ZM6.53333 9.33333H5.13333V4.66667H6.53333V9.33333ZM8.86666 9.33333H7.46666V4.66667H8.86666V9.33333Z"
      fill="currentColor"
    />
  ),
});

export const CircleEmptyIcon = createIcon({
  displayName: 'CircleEmptyIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M12.25 7C12.25 9.89949 9.89949 12.25 7 12.25C4.10051 12.25 1.75 9.89949 1.75 7C1.75 4.10051 4.10051 1.75 7 1.75C9.89949 1.75 12.25 4.10051 12.25 7Z"
      fill="currentColor"
    />
  ),
});

export const CircleXIcon = createIcon({
  displayName: 'CircleXIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25ZM4.66667 5.50488L5.50488 4.66667L5.93291 5.09469L7.00892 6.15287L8.06709 5.09469L8.47728 4.66667L9.33333 5.50488L8.90531 5.93291L7.8293 7.00892L8.90531 8.06709L9.33333 8.47728L8.47728 9.33333L8.06709 8.90531L7.00892 7.8293L5.93291 8.90531L5.50488 9.33333L4.66667 8.47728L5.09469 8.06709L6.15287 7.00892L5.09469 5.93291L4.66667 5.50488Z"
      fill="currentColor"
    />
  ),
});

export const CirclePlayIcon = createIcon({
  displayName: 'CirclePlayIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 7C1.75 4.10078 4.10078 1.75 7 1.75C9.89922 1.75 12.25 4.10078 12.25 7C12.25 9.89922 9.89922 12.25 7 12.25C4.10078 12.25 1.75 9.89922 1.75 7ZM5.80419 9.16774L9.06474 7.08405C9.08015 7.07448 9.09271 7.06181 9.10138 7.04709C9.11006 7.03237 9.11458 7.01604 9.11458 6.99947C9.11458 6.9829 9.11006 6.96657 9.10138 6.95185C9.09271 6.93713 9.08015 6.92446 9.06474 6.91489L5.80419 4.83251C5.78634 4.82113 5.76525 4.81431 5.74326 4.81281C5.72127 4.81132 5.69924 4.81519 5.6796 4.82402C5.65997 4.83285 5.6435 4.84628 5.63202 4.86282C5.62055 4.87936 5.61451 4.89838 5.61458 4.91775V9.0825C5.61462 9.10184 5.62072 9.12079 5.63222 9.13727C5.64372 9.15376 5.66017 9.16714 5.67977 9.17595C5.69936 9.18476 5.72134 9.18865 5.74329 9.1872C5.76524 9.18576 5.78631 9.17902 5.80419 9.16774Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineCircleInfoIcon = createIcon({
  displayName: 'OutlineCircleInfoIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7 1.75C4.10078 1.75 1.75 4.10078 1.75 7C1.75 9.89922 4.10078 12.25 7 12.25C9.89922 12.25 12.25 9.89922 12.25 7C12.25 4.10078 9.89922 1.75 7 1.75ZM7 11.3594C4.59297 11.3594 2.64062 9.40703 2.64062 7C2.64062 4.59297 4.59297 2.64062 7 2.64062C9.40703 2.64062 11.3594 4.59297 11.3594 7C11.3594 9.40703 9.40703 11.3594 7 11.3594Z"
        fill="currentColor"
      />
      <path
        d="M6.34375 4.59375C6.34375 4.7678 6.41289 4.93472 6.53596 5.05779C6.65903 5.18086 6.82595 5.25 7 5.25C7.17405 5.25 7.34097 5.18086 7.46404 5.05779C7.58711 4.93472 7.65625 4.7678 7.65625 4.59375C7.65625 4.4197 7.58711 4.25278 7.46404 4.12971C7.34097 4.00664 7.17405 3.9375 7 3.9375C6.82595 3.9375 6.65903 4.00664 6.53596 4.12971C6.41289 4.25278 6.34375 4.4197 6.34375 4.59375V4.59375ZM7.32812 6.125H6.67188C6.61172 6.125 6.5625 6.17422 6.5625 6.23438V9.95312C6.5625 10.0133 6.61172 10.0625 6.67188 10.0625H7.32812C7.38828 10.0625 7.4375 10.0133 7.4375 9.95312V6.23438C7.4375 6.17422 7.38828 6.125 7.32812 6.125Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineCircleExclamationMarkIcon = createIcon({
  displayName: 'OutlineCircleExclamationMarkIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7 1.75C4.10078 1.75 1.75 4.10078 1.75 7C1.75 9.89922 4.10078 12.25 7 12.25C9.89922 12.25 12.25 9.89922 12.25 7C12.25 4.10078 9.89922 1.75 7 1.75ZM7 11.3594C4.59297 11.3594 2.64062 9.40703 2.64062 7C2.64062 4.59297 4.59297 2.64062 7 2.64062C9.40703 2.64062 11.3594 4.59297 11.3594 7C11.3594 9.40703 9.40703 11.3594 7 11.3594Z"
        fill="currentColor"
      />
      <path
        d="M6.34375 9.40625C6.34375 9.5803 6.41289 9.74722 6.53596 9.87029C6.65903 9.99336 6.82595 10.0625 7 10.0625C7.17405 10.0625 7.34097 9.99336 7.46404 9.87029C7.58711 9.74722 7.65625 9.5803 7.65625 9.40625C7.65625 9.2322 7.58711 9.06528 7.46404 8.94221C7.34097 8.81914 7.17405 8.75 7 8.75C6.82595 8.75 6.65903 8.81914 6.53596 8.94221C6.41289 9.06528 6.34375 9.2322 6.34375 9.40625V9.40625ZM6.67188 7.875H7.32812C7.38828 7.875 7.4375 7.82578 7.4375 7.76562V4.04688C7.4375 3.98672 7.38828 3.9375 7.32812 3.9375H6.67188C6.61172 3.9375 6.5625 3.98672 6.5625 4.04688V7.76562C6.5625 7.82578 6.61172 7.875 6.67188 7.875Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineCircleCheckmarkIcon = createIcon({
  displayName: 'OutlineCircleCheckmarkIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7 1.75C4.10078 1.75 1.75 4.10078 1.75 7C1.75 9.89922 4.10078 12.25 7 12.25C9.89922 12.25 12.25 9.89922 12.25 7C12.25 4.10078 9.89922 1.75 7 1.75ZM7 11.3594C4.59297 11.3594 2.64062 9.40703 2.64062 7C2.64062 4.59297 4.59297 2.64062 7 2.64062C9.40703 2.64062 11.3594 4.59297 11.3594 7C11.3594 9.40703 9.40703 11.3594 7 11.3594Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.71875 7L4.53906 6.1493L6.17969 7.85069L9.4609 4.44792L10.2812 5.29861L6.17969 9.5521L3.71875 7Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineCircleXIcon = createIcon({
  displayName: 'OutlineCircleXIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7 1.75C4.10078 1.75 1.75 4.10078 1.75 7C1.75 9.89922 4.10078 12.25 7 12.25C9.89922 12.25 12.25 9.89922 12.25 7C12.25 4.10078 9.89922 1.75 7 1.75ZM7 11.3594C4.59297 11.3594 2.64062 9.40703 2.64062 7C2.64062 4.59297 4.59297 2.64062 7 2.64062C9.40703 2.64062 11.3594 4.59297 11.3594 7C11.3594 9.40703 9.40703 11.3594 7 11.3594Z"
        fill="currentColor"
      />
      <path
        d="M5.50488 4.66667L4.66666 5.50489L5.09469 5.93291L6.15286 7.00892L5.09469 8.0671L4.66666 8.47729L5.50488 9.33334L5.93291 8.90531L7.00891 7.8293L8.06709 8.90531L8.47728 9.33334L9.33333 8.47729L8.90531 8.0671L7.8293 7.00892L8.90531 5.93291L9.33333 5.50489L8.47728 4.66667L8.06709 5.0947L7.00891 6.15287L5.93291 5.0947L5.50488 4.66667Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CircleClockIcon = createIcon({
  displayName: 'CircleClockIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7 1.75C4.10078 1.75 1.75 4.10078 1.75 7C1.75 9.89922 4.10078 12.25 7 12.25C9.89922 12.25 12.25 9.89922 12.25 7C12.25 4.10078 9.89922 1.75 7 1.75ZM9.06836 8.61367L8.7332 9.0707C8.72591 9.08066 8.71673 9.08907 8.70618 9.09546C8.69563 9.10185 8.68392 9.10609 8.67172 9.10794C8.65952 9.1098 8.64708 9.10922 8.63511 9.10625C8.62313 9.10327 8.61187 9.09797 8.60195 9.09063L6.66367 7.67734C6.6516 7.66867 6.64178 7.65723 6.63505 7.64397C6.62832 7.63072 6.62487 7.61604 6.625 7.60117V4.375C6.625 4.32344 6.66719 4.28125 6.71875 4.28125H7.28242C7.33398 4.28125 7.37617 4.32344 7.37617 4.375V7.27539L9.04727 8.48359C9.08945 8.51289 9.09883 8.57148 9.06836 8.61367Z"
        fill="currentColor"
      />
    </>
  ),
});

export const OutlineCircleClockIcon = createIcon({
  displayName: 'OutlineCircleClockIcon',
  viewBox: '0 0 14 14',
  path: (
    <>
      <path
        d="M7 1.75C4.10078 1.75 1.75 4.10078 1.75 7C1.75 9.89922 4.10078 12.25 7 12.25C9.89922 12.25 12.25 9.89922 12.25 7C12.25 4.10078 9.89922 1.75 7 1.75ZM7 11.3594C4.59297 11.3594 2.64062 9.40703 2.64062 7C2.64062 4.59297 4.59297 2.64062 7 2.64062C9.40703 2.64062 11.3594 4.59297 11.3594 7C11.3594 9.40703 9.40703 11.3594 7 11.3594Z"
        fill="currentColor"
      />
      <path
        d="M9.04724 8.48359L7.37614 7.27539V4.375C7.37614 4.32344 7.33395 4.28125 7.28239 4.28125H6.71872C6.66716 4.28125 6.62497 4.32344 6.62497 4.375V7.60234C6.62497 7.63281 6.63903 7.66094 6.66364 7.67852L8.60192 9.0918C8.64411 9.12227 8.7027 9.11289 8.73317 9.07188L9.06833 8.61484C9.0988 8.57148 9.08942 8.51289 9.04724 8.48359V8.48359Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CircleExclamationMarkIcon = createIcon({
  displayName: 'CircleExclamationMarkIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11 14V7H13V14H11ZM13.25 16.5C13.25 17.1904 12.6904 17.75 12 17.75C11.3096 17.75 10.75 17.1904 10.75 16.5C10.75 15.8096 11.3096 15.25 12 15.25C12.6904 15.25 13.25 15.8096 13.25 16.5Z"
      fill="currentColor"
    />
  ),
});

export const AvailabilityUnknownIcon = createIcon({
  displayName: 'AvailabilityUnknownIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6478 1.49994C14.0264 1.4999 14.3951 1.49985 14.7073 1.52536C15.0502 1.55338 15.4548 1.61948 15.8619 1.82693C16.4264 2.11455 16.8853 2.57349 17.173 3.13797C17.3804 3.54511 17.4465 3.94971 17.4745 4.2926C17.5 4.60484 17.5 4.97352 17.5 5.35209V16.6478C17.5 17.0264 17.5 17.3951 17.4745 17.7073C17.4465 18.0502 17.3804 18.4548 17.173 18.8619C16.8853 19.4264 16.4264 19.8853 15.8619 20.173C15.4548 20.3804 15.0502 20.4465 14.7073 20.4745C14.3951 20.5 14.0264 20.5 13.6478 20.5H10.3521C9.97351 20.5 9.60483 20.5 9.2926 20.4745C8.94971 20.4465 8.54511 20.3804 8.13797 20.173C7.57349 19.8853 7.11455 19.4264 6.82693 18.8619C6.61948 18.4548 6.55338 18.0502 6.52536 17.7073C6.49985 17.3951 6.4999 17.0264 6.49994 16.6478V5.3521C6.4999 4.97353 6.49985 4.60484 6.52536 4.2926C6.55338 3.94971 6.61948 3.54511 6.82693 3.13797C7.11455 2.57349 7.57349 2.11455 8.13797 1.82693C8.54511 1.61948 8.94971 1.55338 9.2926 1.52536C9.60484 1.49985 9.97353 1.4999 10.3521 1.49994H13.6478ZM12 6.95833C13.1867 6.95833 13.8426 7.69688 13.8426 8.27083C13.8426 8.69438 13.738 8.91187 13.6218 9.06059C13.4807 9.24135 13.2749 9.38627 12.9287 9.60805C12.1848 10.0847 11.25 10.8719 11.25 12.3958V13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13V12.3958C12.75 11.6416 13.1485 11.2487 13.7379 10.8711L13.7454 10.8663C14.065 10.6616 14.4848 10.3926 14.804 9.98382C15.1509 9.5397 15.3426 8.98636 15.3426 8.27083C15.3426 6.5666 13.6769 5.45833 12 5.45833C10.323 5.45833 8.65738 6.5666 8.65738 8.27083C8.65738 8.68504 8.99316 9.02083 9.40738 9.02083C9.82159 9.02083 10.1574 8.68504 10.1574 8.27083C10.1574 7.69688 10.8132 6.95833 12 6.95833ZM12.7499 16C12.7499 16.4142 12.4141 16.75 11.9999 16.75C11.5857 16.75 11.2499 16.4142 11.2499 16C11.2499 15.5858 11.5857 15.25 11.9999 15.25C12.4141 15.25 12.7499 15.5858 12.7499 16Z"
      fill="currentColor"
    />
  ),
});

export const AvailabilityInsufficientIcon = createIcon({
  displayName: 'AvailabilityInsufficientIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M14.5303 9.46965C14.8232 9.76254 14.8232 10.2374 14.5303 10.5303L13.0606 12L14.5303 13.4696C14.8232 13.7625 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7625 14.8232 13.4696 14.5303L11.9999 13.0606L10.5303 14.5303C10.2374 14.8232 9.76251 14.8232 9.46962 14.5303C9.17672 14.2374 9.17672 13.7625 9.46962 13.4696L10.9393 12L9.46962 10.5303C9.17672 10.2374 9.17672 9.76254 9.46962 9.46965C9.76251 9.17675 10.2374 9.17675 10.5303 9.46965L11.9999 10.9393L13.4696 9.46965C13.7625 9.17675 14.2374 9.17675 14.5303 9.46965Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6478 2.49994C14.0264 2.4999 14.3951 2.49985 14.7073 2.52536C15.0502 2.55338 15.4548 2.61948 15.8619 2.82693C16.4264 3.11455 16.8853 3.57349 17.173 4.13798C17.3804 4.54511 17.4465 4.94971 17.4745 5.2926C17.5 5.60484 17.5 5.97352 17.5 6.35209V17.6478C17.5 18.0264 17.5 18.3951 17.4745 18.7073C17.4465 19.0502 17.3804 19.4548 17.173 19.8619C16.8853 20.4264 16.4264 20.8853 15.8619 21.173C15.4548 21.3804 15.0502 21.4465 14.7073 21.4745C14.3951 21.5 14.0264 21.5 13.6478 21.5H10.3521C9.97351 21.5 9.60483 21.5 9.2926 21.4745C8.94971 21.4465 8.54511 21.3804 8.13798 21.173C7.57349 20.8853 7.11455 20.4264 6.82693 19.8619C6.61948 19.4548 6.55338 19.0502 6.52536 18.7073C6.49985 18.3951 6.4999 18.0264 6.49994 17.6478V6.3521C6.4999 5.97353 6.49985 5.60484 6.52536 5.2926C6.55338 4.94971 6.61948 4.54511 6.82693 4.13798C7.11455 3.57349 7.57349 3.11455 8.13798 2.82693C8.54511 2.61948 8.94971 2.55338 9.2926 2.52536C9.60484 2.49985 9.97353 2.4999 10.3521 2.49994H13.6478ZM8.16344 4.81896C7.99995 5.13983 7.99995 5.55987 7.99995 6.39995V17.5999C7.99995 18.44 7.99995 18.8601 8.16344 19.1809C8.30725 19.4632 8.53672 19.6926 8.81896 19.8365C9.13983 19.9999 9.55987 19.9999 10.3999 19.9999H13.5999C14.44 19.9999 14.8601 19.9999 15.1809 19.8365C15.4632 19.6926 15.6926 19.4632 15.8365 19.1809C15.9999 18.8601 15.9999 18.44 15.9999 17.5999V6.39995C15.9999 5.55987 15.9999 5.13983 15.8365 4.81896C15.6926 4.53672 15.4632 4.30725 15.1809 4.16344C14.8601 3.99995 14.44 3.99995 13.5999 3.99995H10.3999C9.55987 3.99995 9.13983 3.99995 8.81896 4.16344C8.53672 4.30725 8.30725 4.53672 8.16344 4.81896Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AvailabilityRiskIcon = createIcon({
  displayName: 'AvailabilityRiskIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6479 2.49994C14.0264 2.4999 14.3951 2.49985 14.7074 2.52536C15.0502 2.55338 15.4548 2.61948 15.862 2.82693C16.4265 3.11455 16.8854 3.57349 17.173 4.13797C17.3805 4.54511 17.4466 4.94971 17.4746 5.2926C17.5001 5.60484 17.5001 5.97352 17.5 6.35209V17.6478C17.5001 18.0264 17.5001 18.3951 17.4746 18.7073C17.4466 19.0502 17.3805 19.4548 17.173 19.8619C16.8854 20.4264 16.4265 20.8853 15.862 21.173C15.4548 21.3804 15.0502 21.4465 14.7074 21.4745C14.3951 21.5 14.0264 21.5 13.6479 21.5H10.3521C9.97357 21.5 9.60489 21.5 9.29266 21.4745C8.94977 21.4465 8.54517 21.3804 8.13804 21.173C7.57355 20.8853 7.11461 20.4264 6.82699 19.8619C6.61954 19.4548 6.55344 19.0502 6.52543 18.7073C6.49991 18.3951 6.49996 18.0264 6.5 17.6478V6.3521C6.49996 5.97353 6.49991 5.60484 6.52543 5.2926C6.55344 4.94971 6.61954 4.54511 6.82699 4.13797C7.11461 3.57349 7.57355 3.11455 8.13804 2.82693C8.54517 2.61948 8.94977 2.55338 9.29266 2.52536C9.6049 2.49985 9.97359 2.4999 10.3522 2.49994H13.6479ZM16 10.7597C16 10.9116 15.9309 11.0552 15.8123 11.1501L13.6427 12.8858C13.5577 12.9538 13.4385 12.959 13.3479 12.8986L10.6521 11.1014C10.5615 11.041 10.4423 11.0462 10.3572 11.1142L8.40617 12.6751C8.24248 12.806 7.99999 12.6895 7.99999 12.4798V5.99999C7.99999 4.89542 8.89542 3.99999 9.99999 3.99999H14C15.1046 3.99999 16 4.89542 16 5.99999V10.7597Z"
      fill="currentColor"
    />
  ),
});

export const AvailabilitySplitIcon = createIcon({
  displayName: 'AvailabilitySplitIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6478 2.49994C14.0264 2.4999 14.3951 2.49985 14.7073 2.52536C15.0502 2.55338 15.4548 2.61948 15.8619 2.82693C16.4264 3.11455 16.8853 3.57349 17.173 4.13797C17.3804 4.54511 17.4465 4.94971 17.4745 5.2926C17.5 5.60484 17.5 5.97352 17.5 6.35209V17.6478C17.5 18.0264 17.5 18.3951 17.4745 18.7073C17.4465 19.0502 17.3804 19.4548 17.173 19.8619C16.8853 20.4264 16.4264 20.8853 15.8619 21.173C15.4548 21.3804 15.0502 21.4465 14.7073 21.4745C14.3951 21.5 14.0264 21.5 13.6478 21.5H10.3521C9.97351 21.5 9.60483 21.5 9.2926 21.4745C8.94971 21.4465 8.54511 21.3804 8.13797 21.173C7.57349 20.8853 7.11455 20.4264 6.82693 19.8619C6.61948 19.4548 6.55338 19.0502 6.52536 18.7073C6.49985 18.3951 6.4999 18.0264 6.49994 17.6478V6.3521C6.4999 5.97353 6.49985 5.60484 6.52536 5.2926C6.55338 4.94971 6.61948 4.54511 6.82693 4.13797C7.11455 3.57349 7.57349 3.11455 8.13797 2.82693C8.54511 2.61948 8.94971 2.55338 9.2926 2.52536C9.60484 2.49985 9.97353 2.4999 10.3521 2.49994H13.6478ZM11.5303 10.4696C11.2374 10.1767 10.7625 10.1767 10.4696 10.4696L8.46962 12.4696C8.17672 12.7625 8.17672 13.2374 8.46962 13.5303C8.76251 13.8232 9.23738 13.8232 9.53028 13.5303L10.9999 12.0606L12.4696 13.5303C12.7625 13.8232 13.2374 13.8232 13.5303 13.5303L15.5303 11.5303C15.8232 11.2374 15.8232 10.7625 15.5303 10.4696C15.2374 10.1767 14.7625 10.1767 14.4696 10.4696L12.9999 11.9393L11.5303 10.4696Z"
      fill="currentColor"
    />
  ),
});

export const AvailabilityAvailableIcon = createIcon({
  displayName: 'AvailabilityAvailableIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6478 2.49994C14.0264 2.4999 14.3951 2.49985 14.7073 2.52536C15.0502 2.55338 15.4548 2.61948 15.8619 2.82693C16.4264 3.11455 16.8853 3.57349 17.173 4.13797C17.3804 4.54511 17.4465 4.94971 17.4745 5.2926C17.5 5.60484 17.5 5.97352 17.5 6.35209V17.6478C17.5 18.0264 17.5 18.3951 17.4745 18.7073C17.4465 19.0502 17.3804 19.4548 17.173 19.8619C16.8853 20.4264 16.4264 20.8853 15.8619 21.173C15.4548 21.3804 15.0502 21.4465 14.7073 21.4745C14.3951 21.5 14.0264 21.5 13.6478 21.5H10.3521C9.97351 21.5 9.60483 21.5 9.2926 21.4745C8.94971 21.4465 8.54511 21.3804 8.13797 21.173C7.57349 20.8853 7.11455 20.4264 6.82693 19.8619C6.61948 19.4548 6.55338 19.0502 6.52536 18.7073C6.49985 18.3951 6.4999 18.0264 6.49994 17.6478V6.3521C6.4999 5.97353 6.49985 5.60484 6.52536 5.2926C6.55338 4.94971 6.61948 4.54511 6.82693 4.13797C7.11455 3.57349 7.57349 3.11455 8.13797 2.82693C8.54511 2.61948 8.94971 2.55338 9.2926 2.52536C9.60484 2.49985 9.97353 2.4999 10.3521 2.49994H13.6478Z"
      fill="currentColor"
    />
  ),
});
